const API_HOST =
  process.env.REACT_APP_USERS_API_HOST ||
  process.env.REACT_APP_API_HOST ||
  '';

export const PUBLIC_MARKET_API = `${API_HOST}/public/nxl-market`;
export const PRIVATE_MARKET_API = `${API_HOST}/private/nxl-market`;

export function authHeaders(token) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchJson(url, options = {}) {
  const res = await fetch(url, options);
  const raw = await res.text();

  let data = null;

  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
    data = {
      error: raw?.startsWith('<!DOCTYPE')
        ? `API route returned HTML instead of JSON: ${url}`
        : raw || 'Invalid JSON response',
    };
  }

  if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`);
  return data;
}